<template>
  <div v-if="loading_page === true">
    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <div class="grid_menu mb-5 pl-2">
      <v-card class="menu_team text-center">
        <router-link class="menu_team_link" to="/stock/storage/mainstorage">
          <v-badge v-if="this.$store.state.notify.main != null || this.$store.state.notify.main != 0" color="#eb5c5d" :content="this.$store.state.notify.main" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/received.png">
          </div>
          <div>
            คลังหลัก
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team text-center">
        <router-link class="menu_team_link" to="/stock/storage/expirestorage">
          <v-badge v-if="this.$store.state.notify.expired != null || this.$store.state.notify.expired != 0" color="#eb5c5d" :content="this.$store.state.notify.expired" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/expired.png">
          </div>
          <div>
            คลังใกล้หมดอายุ
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team text-center mr-1">
        <router-link class="menu_team_link" to="/stock/storage/damagedstorage">
          <v-badge v-if="this.$store.state.notify.damaged != null || this.$store.state.notify.damaged != 0" color="#eb5c5d" :content="this.$store.state.notify.damaged" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/box.png">
          </div>
          <div>
            คลังชำรุด
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team text-center">
        <router-link class="menu_team_link" to="/stock/storage/returnstorage">
          <v-badge v-if="this.$store.state.notify.return != null || this.$store.state.notify.return != 0" color="#eb5c5d" :content="this.$store.state.notify.return" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/return-box_1.png">
          </div>
          <div>
            คลังรอคืน
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team text-center">
        <router-link class="menu_team_link" to="/stock/storage/reducedebt">
          <v-badge v-if="this.$store.state.notify.reduct != null || this.$store.state.notify.reduct != 0" color="#eb5c5d" :content="this.$store.state.notify.reduct" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/delivery-time.png">
          </div>
          <div>
            คลังรอลดหนี้
          </div>
        </router-link>
      </v-card>
      <v-card class="menu_team text-center">
        <router-link class="menu_team_link" to="/stock/storage/binstorage">
          <v-badge v-if="this.$store.state.notify.bin != null || this.$store.state.notify.bin != 0" color="#eb5c5d" :content="this.$store.state.notify.bin" class="ml-12 pl-4"></v-badge>
          <v-badge v-else color="#eb5c5d" content="0" class="ml-12 pl-4"></v-badge>
          <div class="menu_team_img">
            <img src="@/assets/delivery-box.png">
          </div>
          <div>
            คลังทิ้ง
          </div>
        </router-link>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "MenuStorage",
  data() {
    return {
      loading_page: false,
    }
  },
  methods: {
    count_notification() {
      this.loading_page = true
      HTTP.post('/inventory/count')
          .then((res) => {
      // console.log(res);

            if (res.data.success === true) {
              this.loading_page = false
              this.$store.state.notify.main = res.data.object.main
              this.$store.state.notify.expired = res.data.object.expired
              this.$store.state.notify.damaged = res.data.object.damaged
              this.$store.state.notify.return = res.data.object.return
              this.$store.state.notify.reduct = res.data.object.reduct
              this.$store.state.notify.bin = res.data.object.bin
              //main
              if (this.$store.state.notify.main < 10) {
                this.$store.state.notify.main = '0' + this.$store.state.notify.main
              }
              else if (this.$store.state.notify.main >= 99) {
                this.$store.state.notify.main = '99+'
              }
              //expired
              if (this.$store.state.notify.expired < 10) {
                this.$store.state.notify.expired = '0' + this.$store.state.notify.expired
              }
              else if (this.$store.state.notify.expired >= 99) {
                this.$store.state.notify.expired = '99+'
              }
              //damaged
              if (this.$store.state.notify.damaged < 10) {
                this.$store.state.notify.damaged = '0' + this.$store.state.notify.damaged
              }
              else if (this.$store.state.notify.damaged >= 99) {
                this.$store.state.notify.damaged = '99+'
              }
              //return
              if (this.$store.state.notify.return < 10) {
                this.$store.state.notify.return = '0' + this.$store.state.notify.return
              }
              else if (this.$store.state.notify.return >= 99) {
                this.$store.state.notify.return = '99+'
              }
              //reduct
              if (this.$store.state.notify.reduct < 10) {
                this.$store.state.notify.reduct = '0' + this.$store.state.notify.reduct
              }
              else if (this.$store.state.notify.reduct >= 99) {
                this.$store.state.notify.reduct = '99+'
              }
              //bin
              if (this.$store.state.notify.bin < 10) {
                this.$store.state.notify.bin = '0' + this.$store.state.notify.bin
              }
              else if (this.$store.state.notify.bin >= 99) {
                this.$store.state.notify.bin = '99+'
              }
            }
          })
    },
  },
  mounted() {
    this.count_notification()
  }
}
</script>

<style scoped>
.grid_menu {
  display: grid;
  grid-template-columns: 16.67% 16.67% 16.67% 16.67% 16.67% 16.67%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1200px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
  }
}
@media only screen and (max-width: 1000px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 33% 33% 33%;
  }
}
@media only screen and (max-width: 700px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
  }
}
.menu_team{
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
  height: 100%;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}

</style>
